import { useEffect, useState } from 'react';

const KEY = 'jobapplier_admin_recent_jobs';
const MAX = 10;

export interface RecentEntry {
  id: number;
  company: string | null;
  title: string | null;
  ts: number;
}

function read(): RecentEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentEntry[];
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

function write(rs: RecentEntry[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(rs.slice(0, MAX)));
  } catch {
    /* swallow quota errors */
  }
}

export function useRecentJobs() {
  const [items, setItems] = useState<RecentEntry[]>(() => read());
  // Listen for cross-tab updates
  useEffect(() => {
    function onStorage(e: StorageEvent) {
      if (e.key === KEY) setItems(read());
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return items;
}

export function pushRecent(entry: Omit<RecentEntry, 'ts'>) {
  const now = Date.now();
  const cur = read().filter((r) => r.id !== entry.id);
  cur.unshift({ ...entry, ts: now });
  write(cur);
}
